import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Home, ArrowRight } from 'lucide-react'
import * as S from './NotFoundStyles'

export default function NotFoundPage() {
  const navigate = useNavigate()

  useEffect(() => {
    // إضافة meta tag noindex لمنع فهرسة الصفحة في محركات البحث
    const metaRobots = document.querySelector('meta[name="robots"]')
    if (metaRobots) {
      metaRobots.setAttribute('content', 'noindex, nofollow')
    } else {
      const meta = document.createElement('meta')
      meta.name = 'robots'
      meta.content = 'noindex, nofollow'
      document.head.appendChild(meta)
    }
  }, [])

  const goHome = () => {
    navigate('/', { replace: true })
  }

  return (
    <S.NotFoundPageContainer>
      <S.NotFoundWrapper>
        <S.NotFoundCard>
          <S.CardBody>
            <S.Hero>
              <S.Number404>404</S.Number404>
              <S.Title>الصفحة غير موجودة</S.Title>
              <S.Subtitle>
                عذراً، الصفحة التي تبحث عنها غير موجودة أو تم نقلها
              </S.Subtitle>
            </S.Hero>

            <S.Actions>
              <S.PrimaryButton onClick={goHome}>
                <Home size={18} style={{ marginLeft: 8 }} />
                العودة للصفحة الرئيسية
              </S.PrimaryButton>
              <S.SecondaryButton onClick={() => window.history.back()}>
                <ArrowRight size={18} style={{ marginRight: 8 }} />
                العودة للصفحة السابقة
              </S.SecondaryButton>
            </S.Actions>
          </S.CardBody>
        </S.NotFoundCard>
      </S.NotFoundWrapper>
    </S.NotFoundPageContainer>
  )
}
